import React from "react";
import { Menu } from "@headlessui/react";
import PropTypes from "prop-types";

export default function DropdownMenuItem(props) {
  return <Menu.Item>{props.children}</Menu.Item>;
}

DropdownMenuItem.propTypes = {
  children: PropTypes.any,
};
